import gql from 'graphql-tag'

export const ADD_ORDER = gql`
mutation insert_orders($orderObj: [orders_insert_input!]!){
  insert_orders(objects: $orderObj, on_conflict: {constraint: orders_orderNumber_key, update_columns: []}) {
    affected_rows
  }
}
`
export const ADD_ORDERDETAIL = gql`
mutation insert_orderDetails($orderDetailObj: [orderDetails_insert_input!]!){
  insert_orderDetails(objects: $orderDetailObj) {
    affected_rows
  }
}
`
export const ADD_ORDER_IN_MANAGE = gql`
 mutation insert_orders($id: uuid!, $clientid: uuid!, $clientobject: jsonb!, $pickuppartyid: uuid!,
  $pickuppartyobject: jsonb!, $droppingpartyid: uuid!, $droppingpartyobject: jsonb!, $materials: jsonb!, $note: String!,
   $priority: Int!, $internalstatus: uuid!, $externalstatus: uuid!, $pickupDate: timestamptz!,
    $orderNumber: String!, $updatedAt: timestamptz!, $createdAt: timestamptz!, $parentOrderId: uuid!) {
  insert_orders(objects: {id: $id, clientid: $clientid, clientobject: $clientobject, pickuppartyid: $pickuppartyid,
  pickuppartyobject: $pickuppartyobject, droppingpartyid: $droppingpartyid, droppingpartyobject: $droppingpartyobject, materials: $materials,
   note: $note, priority: $priority, internalstatus: $internalstatus, externalstatus: $externalstatus,
    pickupDate: $pickupDate, orderNumber: $orderNumber, updatedAt: $updatedAt, createdAt: $createdAt, parentOrderId: $parentOrderId}) {
    returning {
      id
 }
}
  }
`

export const UPDATE_PARENT_ORDER = gql`
 mutation ($pickuppartyid: uuid!,$pickuppartyobject: jsonb!,$materials: jsonb!,$orderNumber: String!,
 $parentOrderId: uuid!, $updatedAt: timestamptz!, $note: String!, $internalstatus: uuid!) {
 update_orders (
    where: {id: {_eq: $parentOrderId}}
    _set: {materials: $materials, pickuppartyid: $pickuppartyid, pickuppartyobject: $pickuppartyobject,
     orderNumber: $orderNumber, updatedAt: $updatedAt, note: $note, internalstatus: $internalstatus}
  ) {
    returning {
      id
      orderNumber
     }
    }

  }
`
export const UPDATE_ORDER_BY_STATUS = gql`
 mutation ($orderId: uuid!, $internalstatus: uuid!) {
 update_orders (
    where: {id: {_eq: $orderId}}
    _set: {internalstatus: $internalstatus}
  ) {
    returning {
      id
      orderNumber
     }
    }

  }
`
export const UPDATE_ORDER_BY_MATERIALS = gql`
 mutation ($orderId: uuid!, $materials: jsonb!) {
 update_orders (
    where: {id: {_eq: $orderId}}
    _set: {materials: $materials}
  ) {
    returning {
      id
      orderNumber
     }
    }

  }
`
export const ADD_ORDER_NOTE = gql`
 mutation insert_notes($orderId: uuid!,$note: String!,$createdBy: uuid!,$lastUpdatedBy: uuid!,$createdOn: timestamptz!,$updatedOn: timestamptz!, $type: String) {
  insert_notes(objects: {orderId: $orderId, note: $note, createdBy: $createdBy, lastUpdatedBy: $lastUpdatedBy, createdOn: $createdOn, updatedOn:$updatedOn, type: $type}) {
    returning {
      id
 }
}
  }
`
export const WHILE_CANCEL_ORDER = gql`
mutation while_cancel_order($orderId: uuid!, $order: orders_set_input, $orderDetailId: uuid!, $orderDetail: orderDetails_set_input,
                            $note: [notes_insert_input!]!) {
  update_orders(where: {id: {_eq: $orderId}}, _set: $order){
   affected_rows
  }
  update_orderDetails(where: {id: {_eq: $orderDetailId}}, _set: $orderDetail){
   affected_rows
  }
  insert_notes(objects: $note){
   affected_rows
  }
}`

export const UPDATE_ORDER_INSERT_CLIENT_INVOICE = gql`
mutation ($id: uuid!, $order:orders_set_input, $clientInvoice:[clientInvoices_insert_input!]!) {
  update_orders(where: {id: {_eq: $id}}, _set: $order){
   affected_rows
  }
  insert_clientInvoices(objects: $clientInvoice, on_conflict: {constraint: clientInvoices_orderId_key, update_columns: []}){
   affected_rows
  }
}`

export function generate_UPDATE_ORDER_DATA(table) {
    return gql`
 mutation update_${table}($id: uuid!, $obj: ${table}_set_input) {
 update_${table} (
    where: {id: {_eq: $id}}
    _set: $obj
  ) {
    returning {
      id
     }
    }

  }
`
}
